import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth/auth.guards';
import { FILE_ENCRYPTION_ENABLED } from './core/features';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    title: 'Sign in · Notaryx',
    loadComponent: () => import('./features/login/login'),
  },
  {
    path: '',
    canActivate: [authGuard],
    title: 'Notaryx',
    loadComponent: () => import('./features/notary/notary'),
  },
  // Settings only holds the file encryption switch for now (core/features.ts).
  ...(FILE_ENCRYPTION_ENABLED
    ? [
        {
          path: 'settings',
          canActivate: [authGuard],
          title: 'Settings · Notaryx',
          loadComponent: () => import('./features/settings/settings'),
        },
      ]
    : []),
  { path: '**', redirectTo: '' },
];
